import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { X } from "lucide-react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
interface EmailOnlyMissingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  onSubmitEmail?: (email: string) => void;
}
const EmailOnlyMissingModal: React.FC<EmailOnlyMissingModalProps> = ({
  isOpen,
  onClose,
  onContinue,
  onSubmitEmail
}) => {
  const schema = z.object({
    email: z.string().min(1, "L'email est requis").email("Adresse e-mail incorrecte").refine(email => {
      const freeDomains = ["gmail.com", "googlemail.com", "hotmail.com", "hotmail.fr", "outlook.com", "outlook.fr", "live.com", "live.fr", "msn.com", "yahoo.com", "yahoo.fr", "ymail.com", "rocketmail.com", "icloud.com", "me.com", "mac.com", "aol.com", "aol.fr", "laposte.net", "orange.fr", "wanadoo.fr", "sfr.fr", "neuf.fr", "club-internet.fr", "cegetel.net", "numericable.fr", "free.fr", "aliceadsl.fr", "libertysurf.fr", "infonie.fr", "bbox.fr", "tele2.fr", "protonmail.com", "proton.me", "pm.me", "zoho.com", "gmx.fr", "gmx.com", "gmx.net", "mail.com", "yandex.com", "yandex.fr", "inbox.com", "bluewin.ch", "t-online.de", "web.de", "posteo.net", "caramail.com", "netcourrier.com", "keemail.me", "tutanota.com", "ueir.jci"];
      const domain = email.split('@')[1];
      return !freeDomains.includes(domain?.toLowerCase());
    }, "Veuillez utiliser votre email professionnel")
  });
  type FormValues = z.infer<typeof schema>;
  const form = useForm<FormValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      email: ""
    },
    mode: "onChange"
  });
  const onSubmit = (data: FormValues) => {
    if (onSubmitEmail) {
      onSubmitEmail(data.email);
    }
  };
  if (!isOpen) return null;
  return <div className="fixed top-[42%] -translate-y-1/2 left-6 bg-white border border-gray-200 rounded-lg shadow-lg p-4 max-w-sm animate-fade-in z-[200000]">
      {/* Bouton fermer */}
      <button onClick={onClose} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors">
        <X className="h-4 w-4" />
      </button>

      {/* Contenu */}
      <div className="pr-6">
        <h3 className="font-semibold text-lg mb-2 text-gray-900">
          Il ne manque plus que votre email !
        </h3>
        <p className="text-sm text-gray-600 mb-4">Recevez des suggestions personnalisées pour votre événement. Gratuit et sans engagement</p>
        
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormField control={form.control} name="email" render={({
            field
          }) => <FormItem>
                  <FormControl>
                    <Input type="email" placeholder="Entrez votre adresse e-mail professionnelle" className="text-sm h-10" {...field} />
                  </FormControl>
                  <FormMessage className="text-xs" />
                </FormItem>} />
            
            <div className="flex flex-col gap-2">
              <Button type="submit" className="w-full bg-cta-green hover:bg-cta-green/90 text-cta-green-foreground text-sm py-2">
                Envoyer
              </Button>
              <button type="button" onClick={onClose} className="text-xs text-gray-500 hover:text-gray-700 transition-colors">
                Fermer définitivement
              </button>
            </div>
          </form>
        </Form>
      </div>
    </div>;
};
export default EmailOnlyMissingModal;